document.addEventListener('DOMContentLoaded', () => {
  const track = document.querySelector('.problem-cards__track');
  if (!track) return;

  const grid = track.querySelector('.problem-cards__grid');
  const slides = grid ? Array.from(grid.querySelectorAll('.swiper-slide')) : [];
  const dots = document.querySelectorAll('.problem-cards__dots-btn');

  if (grid && dots.length) {
    const setActiveDot = (index) => {
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = slides.indexOf(entry.target);
            if (index !== -1) setActiveDot(index);
          }
        });
      },
      { root: grid, threshold: 0.6 }
    );

    slides.forEach((slide) => observer.observe(slide));

    dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        const slide = slides[index];
        if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'start', block: 'nearest' });
      });
    });
  }
});
